import { VISIT } from "../constants";
import { instance } from "../../axios";

let getVisitsAction = (patientId) => {
  return (dispatch) => {
    dispatch({ type: VISIT.GET_VISITS });
    instance
      .get(`/visit?patientId=${patientId}`)
      .then((results) => {
        dispatch({ type: VISIT.GET_VISITS_SUCCESS, payload: results.data });
      })
      .catch((error) => {
        dispatch({ type: VISIT.GET_VISITS_FAILURE, payload: error });
      });
  };
};

let createVisitAction = (body) => {
  return (dispatch) => {
    dispatch({ type: VISIT.CREATE_VISIT });
    return instance
      .post("/visit", body)
      .then((results) => {
        dispatch({ type: VISIT.CREATE_VISIT_SUCCESS, payload: results.data });
        dispatch(getVisitsAction(body.patientId));
        return results.data;
      })
      .catch((error) => {
        dispatch({ type: VISIT.CREATE_VISIT_FAILURE, payload: error });
        throw error;
      });
  };
};

let validateVisitAction = (visitId, patientId, body) => {
  return (dispatch) => {
    dispatch({ type: VISIT.VALIDATE_VISIT });
    return instance
      .post(`/visit/${visitId}/validate`, body)
      .then((results) => {
        dispatch({ type: VISIT.VALIDATE_VISIT_SUCCESS, payload: results.data });
        dispatch(getVisitsAction(patientId));
        return results.data;
      })
      .catch((error) => {
        dispatch({ type: VISIT.VALIDATE_VISIT_FAILURE, payload: error });
        throw error;
      });
  };
};

let deleteVisitAction = (visitId, patientId) => {
  return (dispatch) => {
    dispatch({ type: VISIT.DELETE_VISIT });
    instance
      .delete(`/visit/${visitId}`)
      .then(() => {
        dispatch({ type: VISIT.DELETE_VISIT_SUCCESS });
        dispatch(getVisitsAction(patientId));
      })
      .catch((error) => {
        dispatch({ type: VISIT.DELETE_VISIT_FAILURE, payload: error });
      });
  };
};

let setVisitPatientId = (patientId) => ({
  type: VISIT.SET_PATIENT_ID,
  payload: patientId,
});

let cleanVisitAction = () => ({ type: VISIT.CLEAN_VISIT });

export {
  getVisitsAction,
  createVisitAction,
  validateVisitAction,
  deleteVisitAction,
  setVisitPatientId,
  cleanVisitAction,
};
